<template>
    
    <div>

        <div class="row row-cols-1 row-cols-lg-2 g-4">

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Supplier Group') }}</legend>
                            <text-input label="name" v-model="form.name" :error="form.errors.name" />
                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="d-flex align-items-center w-100">
                <submit-button :form="form" />
                <button type="button" class="btn link-danger" @click="destroy" v-if="supplierGroup">
                    {{ __('Löschen') }}
                </button>
            </div>
            
        </div>
        
    </div>

</div>

</div>
</template>

<script>
    import TextInput from '@/shared/Inputs/TextInput';
    import SelectInput from '@/shared/Inputs/SelectInput';
    import TextareaInput from '@/shared/Inputs/TextareaInput';
    import CheckboxInput from '@/shared/Inputs/CheckboxInput';
    import SubmitButton from '@/shared/Inputs/SubmitButton';

    export default {
        props: [
            'form',
            'supplierGroup',
        ],
        data() {
            return {

            }
        },
        components: {
            TextInput,
            SelectInput,
            TextareaInput,
            CheckboxInput,
            SubmitButton,
        },
        watch: {
        },
        methods: {
            destroy() {
                if (confirm(this.__('Sind Sie sicher?'))) {
                    this.$inertia.delete(this.route('admin.supplier-groups.destroy', this.supplierGroup));
                }
            },
        },
    }
</script>
